import { ArrowBack } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import moment from "moment-timezone";
import React from "react";
import PaginatedSearchResults from "../../common/components/data-display/PaginatedSearchResults";
import StockLogService from "../../common/service/StockLogService";
import { usePointOfSaleContext } from "./PointOfSaleContextProvider";
import PointOfSaleInventoryProductSummary from "./PointOfSaleInventoryProductSummary";
import PointOfSaleInventorySearchCriteria from "./PointOfSaleInventorySearchCriteria";

export default function PointOfSaleInventorySearch({ saleDate }) {
  const {
    setItemToAdd,
    pointOfSaleSearchRef,
    setIsShoppingInventory,
    backToPresaleOrder,
    backToAdvancedRequest,
  } = usePointOfSaleContext();
  const defaultSearchCriteria = {
    searchText: "",
    colors: [],
    startDate: moment(saleDate).add(-10, "days").format("YYYY-MM-DD"),
    endDate: moment(saleDate).add(1, "day").startOf("day").format("YYYY-MM-DD"),
    supplier: null,
    page: 1,
    specificProductInstance: null,
    advancedProductDisplay: null,
    itemsPerPage: 24,
  };

  React.useEffect(() => {
    pointOfSaleSearchRef.current?.rerunSearch(defaultSearchCriteria);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saleDate]);

  return (
    <Box data-testid="sales-inventory" flexDirection="column">
      <Box justifyContent="space-between">
        <Button
          size="large"
          onClick={() => setIsShoppingInventory(false)}
          startIcon={<ArrowBack />}
          variant="contained"
          sx={{ mt: 1, ml: 1 }}
        >
          Return to Invoice
        </Button>
        {backToPresaleOrder && (
          <Button
            size="large"
            onClick={backToPresaleOrder}
            startIcon={<ArrowBack />}
            variant="contained"
            sx={{ mt: 1, ml: 1 }}
          >
            Back to Market Sales Order
          </Button>
        )}
        {backToAdvancedRequest && (
          <Button
            size="large"
            onClick={backToAdvancedRequest}
            startIcon={<ArrowBack />}
            variant="contained"
            sx={{ mt: 1, ml: 1 }}
          >
            Back to Product Request
          </Button>
        )}
      </Box>
      <PaginatedSearchResults
        ref={pointOfSaleSearchRef}
        navigateOnSearch={false}
        SearchCriteriaComponent={PointOfSaleInventorySearchCriteria}
        fetchSearchResults={StockLogService.getPointOfSaleInventory}
        defaultSearchCriteria={defaultSearchCriteria}
        ResultDisplayComponent={PointOfSaleInventoryProductSummary}
        SearchResultsProps={{
          sx: {
            display: "flex",
            gap: 2.5,
            flexWrap: "wrap",
            justifyContent: "space-around",
          },
        }}
        PaginationProps={{
          itemsPerPageOptions: [
            { label: "24", value: 24 },
            { label: "48", value: 48 },
            { label: "100", value: 100 },
          ],
        }}
        onClickSearchResult={(item) => {
          setItemToAdd(item);
        }}
      />
    </Box>
  );
}
